import { makeRequest } from 'common/async-data';
import { IApiGenericReturn, IJobs } from 'common/api-interfaces';

export const fetchJobs = () =>
  makeRequest<IApiGenericReturn<{ datas: IJobs[] }>>({
    url: `${process.env.API_BASE_URL}/job/all`,
    method: 'POST',
  });
